import VerifyCertificate from './VerifyCertificate'

export default VerifyCertificate
